<template>
  <el-dialog class="submit-dialog" :visible.sync="dialogVisible" :show-close="false" width="460px" append-to-body>
    <div class="submitMian">{{ msg }}</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      msg: ''
    }
  },
  methods: {
    open(msg) {
      this.dialogVisible = true
      this.msg = msg
    }
  }
}
</script>
<style lang="scss" scoped>
.submit-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 10px 20px;
    }
  }
}
</style>
